/**
 * @param {*} value
 * @returns {string|undefined}
 */
function accountNo (value) {
  if (!value) return

  return value
}

module.exports = { accountNo }
